import { render, staticRenderFns } from "./LogsTab.vue?vue&type=template&id=9a10dd80"
import script from "./LogsTab.vue?vue&type=script&lang=js"
export * from "./LogsTab.vue?vue&type=script&lang=js"
import style0 from "./LogsTab.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports